import React from 'react'

const LAT = 50.24095789519349
const LNG = 16.4046010244367

function Mapa() {
  const osmEmbedUrl =
    `https://www.openstreetmap.org/export/embed.html?bbox=${LNG - 0.01}%2C${LAT - 0.006}%2C${LNG + 0.01}%2C${LAT + 0.006}&layer=mapnik&marker=${LAT}%2C${LNG}`
  const mapyUrl = `https://mapy.cz/zakladni?source=coor&id=${LNG}%2C${LAT}&x=${LNG}&y=${LAT}&z=17`
  const osmUrl = `https://www.openstreetmap.org/?mlat=${LAT}&mlon=${LNG}#map=17/${LAT}/${LNG}`

  return (
    <div className="mapa-container">
      <h3 style={{ textAlign: 'center', marginBottom: '1rem', color: '#8b4513', fontFamily: 'Georgia, serif' }}>
        Poloha chaty
      </h3>

      <iframe
        title="Poloha chaty Jílovanka"
        src={osmEmbedUrl}
        width="100%"
        height="300"
        style={{ border: 0, borderRadius: 8 }}
        loading="lazy"
      />

      <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', flexWrap: 'wrap', marginTop: '0.75rem' }}>
        <a href={mapyUrl} target="_blank" rel="noreferrer" style={{ color: '#8b4513', fontWeight: 700 }}>
          Otevřít v Mapy.cz
        </a>
        <a href={osmUrl} target="_blank" rel="noreferrer" style={{ color: '#8b4513', fontWeight: 700 }}>
          Otevřít v OpenStreetMap
        </a>
      </div>
    </div>
  )
}

export default Mapa
